<script>
  export let scale
  export let values
  export let fill = 'red'
  export let stroke = 'none'
  export let radius = 3
  export let strokeWidth = 1

  export let data
</script>

{#each data as d}
  <circle
    cx={scale.x(d[values.x])}
    cy={scale.y(d[values.y])}
    r={radius}
    style="stroke: {stroke}; stroke-width: {strokeWidth}px; fill: {fill};"
  />
{/each}
